import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="policy-container1">
      <h1 className="policy-containerh">Terms and Conditions</h1>
      <p className="last-updated1"><strong>Last Updated:</strong> July 14, 2023</p>
      
      <section>
        <h2 className='policy-containerh2'>1. Acceptance of Terms</h2>
        <p className='policy-containerp'>By accessing and using the Makkal Sinthanai Peravai website, you accept and agree to be bound by these Terms and Conditions.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>2. Intellectual Property</h2>
        <p>All content on this Site, including text, graphics, logos, and images, is the property of Makkal Sinthanai Peravai and is protected by copyright laws.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>3. User Conduct</h2>
        <p>You agree not to:</p>
        <ul className='policy-containerul'>
          <li className='policy-containerli'>Use the Site for any unlawful purpose</li>
          <li className='policy-containerli'>Attempt to gain unauthorized access to any part of the Site</li>
          <li className='policy-containerli'>Post or transmit any harmful or offensive content</li>
          <li className='policy-containerli'>Interfere with the proper working of the Site</li>
        </ul>
      </section>

      <section>
        <h2 className='policy-containerh2'>4. Disclaimer of Warranties</h2>
        <p>The Site is provided "as is" without any warranties of any kind, either express or implied. We do not warrant that the Site will be uninterrupted or error-free.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>5. Limitation of Liability</h2>
        <p>Makkal Sinthanai Peravai shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of the Site.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>6. Governing Law</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>7. Changes to Terms</h2>
        <p>We reserve the right to modify these Terms at any time. Your continued use of the Site after such modifications constitutes your acceptance of the new Terms.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>8. Contact Information</h2>
        <p>For any questions regarding these Terms and Conditions, please contact us at <a href="mailto:contact@makkalsinthanaiperavai.org">contact@makkalsinthanaiperavai.org</a>.</p>
      </section>
    </div>
  );
};

export default TermsAndConditions;